module.exports = __webpack_public_path__ + "static/media/landing.39221a2e.png";